import React, { useState } from 'react'
import styled from 'styled-components'
import { Button } from './Button'
import DatePicker from 'react-datepicker'
import moment from 'moment'
import { createReport, fetchReports } from '../../store/data-export/reportsSlice'
import { useDispatch } from 'react-redux'

import "react-datepicker/dist/react-datepicker.css";

const StyledGeneratedReport = styled.div`;
  display: flex;
  padding: 20px 0;
  justify-content: center;
`;

const StyledDatePickerInput = styled.input`
  font-size: 14px;
  border: 0;
  padding: 5px;
  margin: 5px;
  width: 100px;
  display: block;
  text-align: center;
  color: #555;
`;

const ExampleCustomInput = ({ value, onClick }: { value?: any; onClick?: any; }) => (
  <StyledDatePickerInput className="example-custom-input" onClick={onClick} value={value}/>
);

const EmailRecipientsContainer = styled.div`
  display: flex;
`;

const EmailRecipientsInput = styled.input`
  display: block;
`;

const EmailRecipientsLabel = styled.div`
  color: #555;
  font-size: 14px;
  padding: 8px;
  margin: 5px;
`;

const ButtonCluster = styled.div`
  display: flex;
`;

const EmailRecipients = ({ selected, onClick }: { selected: boolean, onClick: any }) => {
  
  return (
    <EmailRecipientsContainer>
      <EmailRecipientsInput type="checkbox" value="true" onClick={onClick}/>
      <EmailRecipientsLabel>Email Recipients</EmailRecipientsLabel>
    </EmailRecipientsContainer>
  )
}

const StartText = styled.div`
  font-size: 16px;
  color: #555;
  margin: 11px 10px 0 0;
`;

const getReportDuration = (template_id) => {
  if (template_id == 1) {
    return 'Daily';
  } else if (template_id == 2) {
    return 'Weekly';
  } else if (template_id == 3 || template_id == 4) {
    return 'Monthly';
  } else {
    return '';
  }
}

export const GenerateReport = ({ scheduled_report }: { scheduled_report: any }) => {
  
  const [startDate, setStartDate] = useState(new Date())
  const [emailRecipients, setEmailRecipients] = useState(false)
  const dispatch = useDispatch()

  return (
    <StyledGeneratedReport>
      <ButtonCluster>
        {false?<EmailRecipients selected={emailRecipients} onClick={e => setEmailRecipients(e.value)}/>:null}
        <StartText>Start</StartText>
        <DatePicker selected={startDate} onChange={date => setStartDate(date)} dateFormat="yyyy/MM/dd" customInput={<ExampleCustomInput />}/>
        <Button onClick={() => { dispatch(createReport(scheduled_report.station_id, scheduled_report.report_schedule_id, moment(startDate).format('YYYY-MM-DD'))) }} color='#1c94c4' width='200px' background='#f6f6f6' border='1px solid #cccccc'>Generate {getReportDuration(scheduled_report.template_id)} Report</Button>
      </ButtonCluster>
    </StyledGeneratedReport>
  )
}